import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { ActionTypeService } from "../report-services/action-type.service";
import { DistrictSchoolService } from "../report-services/district-school.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { SchoolGroupService } from "../report-services/school-group.service";

@Component({
	selector: "app-district-monthly-referral-averages",
	templateUrl: "./district-monthly-referral-averages.component.html",
	styleUrls: ["./district-monthly-referral-averages.component.css"],
})
export class DistrictMonthlyReferralAveragesComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private schoolgroupService: SchoolGroupService,
		private actiontypeService: ActionTypeService,
		private districtschoolService: DistrictSchoolService,
		private dialogService: DialogService
	) {}
	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		DistrictSchoolID: 0,
		StartMonthID: 0,
		StartYear: 0,
		EndMonthID: 0,
		EndYear: 0,
		ActionTypeID: 0,
		SchoolGroupID: 0,
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	DistrictSchoolList: any = [];
	YearList: any = [];
	ActionTypeList: any = [];
	SchoolGroupList: any = [];
	ImageLogoList: any = [];

	MonthList: any = [
		{
			ID: 1,
			Desc: "January",
		},
		{
			ID: 2,
			Desc: "February",
		},
		{
			ID: 3,
			Desc: "March",
		},
		{
			ID: 4,
			Desc: "April",
		},
		{
			ID: 5,
			Desc: "May",
		},
		{
			ID: 6,
			Desc: "June",
		},
		{
			ID: 7,
			Desc: "July",
		},
		{
			ID: 8,
			Desc: "August",
		},
		{
			ID: 9,
			Desc: "September",
		},
		{
			ID: 10,
			Desc: "October",
		},
		{
			ID: 11,
			Desc: "November",
		},
		{
			ID: 12,
			Desc: "December",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 291;
	subscription: any;

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadDistrictSchoolList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.report.DistrictSchoolID = school.SchoolID;
			this.loadLogolist();
		});

		this.loadYearList();
		this.loadActionTypeList();
		this.loadSchoolGroupList();

		var CurrentMonthIndex = new Date().getMonth() + 1; //JS Date 0 based, report is 1 based

		this.report.StartMonthID = CurrentMonthIndex;
		this.report.EndMonthID = CurrentMonthIndex;
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadDistrictSchoolList() {
		this.report.DistrictSchoolID = 0;
		var result = this.districtschoolService.loadDistrictSchoolList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.DistrictSchoolList = response;

				this.report.DistrictSchoolID = this.DistrictSchoolList[0].SchoolID;
			},
			(error) => {}
		);
	}

	private loadYearList() {
		var currentYear = new Date().getFullYear();

		this.YearList = [];
		for (var i = currentYear; i >= 2007; i--) {
			this.YearList = [...this.YearList, i];
		}

		this.report.StartYear = this.YearList[0];
		this.report.EndYear = this.YearList[0];
	}

	private loadActionTypeList() {
		this.report.ActionTypeID = 0;
		var result = this.actiontypeService.loadActionTypeList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ActionTypeList = response;

				this.report.ActionTypeID = this.ActionTypeList[0].ActionTypeID;
			},
			(error) => {}
		);
	}

	private loadSchoolGroupList() {
		this.report.SchoolGroupID = 0;
		var result = this.schoolgroupService.loadSchoolGroupList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.SchoolGroupList = response;

				this.report.SchoolGroupID = this.SchoolGroupList[0].SchoolGroupID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.DistrictSchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.DistrictSchoolID) {
		//   this.errorMessage = "Select the DistrictSchool"
		//   return;
		// }

		// if (!this.report.StartMonth) {
		//   this.errorMessage = "Select the Start Month"
		//   return;
		// }

		// if (!this.report.StartYear) {
		//   this.errorMessage = "Select the Start Year"
		//   return;
		// }

		// if (!this.report.EndMonth) {
		//   this.errorMessage = "Select the End Month"
		//   return;
		// }

		// if (!this.report.EndYear) {
		//   this.errorMessage = "Select the End Year"
		//   return;
		// }

		// if (!this.report.ActionTypeID) {
		//   this.errorMessage = "Select the Action Type"
		//   return;
		// }

		// if (!this.report.SchoolGroupID) {
		//   this.errorMessage = "Select the School Group"
		//   return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 291;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: DistrictSchoolID
		strParam += this.report.DistrictSchoolID + "|DistrictSchoolID";

		//Parameter 2: StartMonthID
		strParam += "," + this.report.StartMonthID + "|StartMonthID";

		//Parameter 3: StartYearID
		strParam += "," + this.report.StartYear + "|StartYearID";

		//Parameter 4: EndMonthID
		strParam += "," + this.report.EndMonthID + "|EndMonthID";

		//Parameter 5: EndYearID
		strParam += "," + this.report.EndYear + "|EndYearID";

		//Parameter 6: ActionType
		strParam += "," + this.report.ActionTypeID + "|ActionType";

		//Parameter 7: SchoolGroupID
		strParam += "," + this.report.SchoolGroupID + "|SchoolGroupID";

		//Parameter 8: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
